/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */

import React, {memo, MouseEventHandler} from 'react';
import {CancelIcon} from '../../icons/CancelIcon';
import {dlsAlt} from '../../theme/theme';
import IonTooltip from '../tooltip/IonTooltip';
import {IconButton} from './IconButton';

interface StopActionRowButtonProps extends StyleProps {
  onClick: MouseEventHandler;
  tooltipCaption?: string;
  isPending?: boolean;
}

interface StyleProps {
  isDisabled?: boolean;
}

const customIconButtonStyles = () => ({
  root : {
    padding      : '3px 6px',
    margin       : '3px 6px',
    '&$disabled' : {
      background : ({isDisabled}: StyleProps) => !isDisabled ? dlsAlt('components', 'btn', 'iconBackground') : 'inherit'
    }
  }
});

/**
 * Re-usable 'cancel' or 'stop' button that fits the {@link IonGrid} default row height.
 */
export const StopActionRowButton = ({
  tooltipCaption,
  onClick,
  isDisabled = false,
  isPending = false
}: StopActionRowButtonProps): JSX.Element => (
  <IonTooltip caption={tooltipCaption}>
    <IconButton onClick={onClick}
      shouldWrap
      disabled={isDisabled}
      disableHover={isDisabled}
      styleOverrides={customIconButtonStyles}
      styleOverridesProps={{isDisabled}}
      icon={<CancelIcon disable={isPending} opacity={0.4} />}/>
  </IonTooltip>
);

export default memo(StopActionRowButton);
